<div class="hidden max-h-[38rem] w-full justify-evenly gap-16 overflow-hidden md:flex" [ngClass]="class()">
  @for (list of navigation(); track $index) {
    <div class="flex flex-row gap-10">
      @if (list.children && !list.text) {
        <div class="flex flex-col gap-16">
          @for (childList of list.children; track $index) {
            <ng-container *ngTemplateOutlet="menuColumn; context: { list: childList }" />
          }
        </div>
      } @else {
        <ng-container *ngTemplateOutlet="menuColumn; context: { list: list }" />
      }
    </div>
  }
</div>

<ng-template #menuColumn let-list="list">
  <div class="flex max-w-48 flex-col gap-5">
    <span class="px-3 text-lg font-bold leading-6" heading>{{ list.text }}</span>
    <ul class="flex flex-col">
      @for (item of list.children; track $index) {
        <li class="flex text-[0.938rem] leading-5">
          <a
            class="flex w-full rounded px-3 py-1.5 hover:bg-[#002024]/10 dark:hover:bg-white/10"
            [href]="(item.link?.route?.path ?? item.link?.url)?.includes('/media/') ? ((item.link?.route?.path ?? item.link?.url) | cmsMediaPrefix) : ((item.link?.route?.path ?? item.link?.url) | sanitizeUrl)"
            [attr.target]="item.link?.target"
            [attr.aria-description]="item.link?.title"
            [shebaGtmClick]="{ user_action: 'user_clicks_footer' }"
            routerLinkDetector
            matRipple
          >
            {{ item.text }}
          </a>
        </li>
      }
    </ul>
  </div>
</ng-template>

<mat-accordion class="w-full md:hidden" [ngClass]="class()" displayMode="flat">
  @for (list of navigation(); track list.text; let index = $index) {
    @if (list.children && !list.text) {
      @for (childList of list.children; track $index) {
        <ng-container *ngTemplateOutlet="menuAccordion; context: { list: childList }" />
      }
    } @else {
      <ng-container *ngTemplateOutlet="menuAccordion; context: { list: list }" />
    }
  }
</mat-accordion>

<ng-template #menuAccordion let-list="list">
  <mat-expansion-panel class="mat-elevation-z0" 
  [ngClass]="{'!bg-[#012C31] !text-white': !lightMode()}"
  #matExpansionPanel hideToggle>
    <mat-expansion-panel-header
      class="border-t border-[#D3D8EF] [.mat-expanded_&]:border-b [.mat-expansion-panel:last-child_&]:border-b"
      [ngClass]="{'!bg-[#012C31] !text-white': !lightMode()}"
      >
      <mat-panel-title class="text-xl leading-6"
      [ngClass]="{'bg-[#012C31] !text-white': !lightMode()}"

      >
        {{ list.text }}
      </mat-panel-title>
      <div
        class="origin-center place-content-center transition-transform"
        [ngClass]="{ 'rotate-180': matExpansionPanel.expanded }"
      >
        <sheba-arrow-down-icon />
      </div>
    </mat-expansion-panel-header>
    <ul class="flex flex-col"
    [ngClass]="{'bg-[#012C31] !text-white': !lightMode()}"
    >
      @for (item of list.children; track item) {
        <li class="flex text-[0.938rem] leading-5">
          <a
            class="flex w-full rounded px-3 py-1.5 hover:bg-[#002024]/10 dark:hover:bg-white/10"
            [href]="(item.link?.route?.path ?? item.link?.url)?.includes('/media/') ? ((item.link?.route?.path ?? item.link?.url) | cmsMediaPrefix) : ((item.link?.route?.path ?? item.link?.url) | sanitizeUrl)"
            [attr.target]="item.link?.target"
            [attr.aria-description]="item.link?.title"
            routerLinkDetector
            matRipple
          >
            {{ item.text }}
          </a>
        </li>
      }
    </ul>
  </mat-expansion-panel>
</ng-template>
